import { Injectable } from '@angular/core';
import { Params } from '@angular/router';

import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { MenuItem } from '../models/menu-item.model';
import * as actions from './navigation.actions';
import { NavigationSelectors } from './navigation.selectors';

@Injectable({ providedIn: 'root' })
export class NavigationFacade {
    constructor(private store: Store) {}
    @Select(NavigationSelectors.menu) menu$: Observable<MenuItem[]>;
    @Select(NavigationSelectors.userMenu) userMenu$: Observable<MenuItem[]>;

    loadAuthenticatedMenu = () => this.store.dispatch(new actions.LoadAuthenticatedMenuAction());
    clearMenu = () => this.store.dispatch(new actions.ClearMenuAction());
    navigate = (url: string, queryParams: Params = null, isClubContext: boolean = true) => this.store.dispatch(new actions.NavigateAction(url, queryParams, isClubContext));
    refreshMenu = () => this.store.dispatch(new actions.RefreshMenuAction());
    goBack = () => this.store.dispatch(new actions.GoBack());
}
